import { defineComponent as _defineComponent } from 'vue'
import {
  Ref, computed, getCurrentInstance, onBeforeUnmount, onMounted, ref,
} from 'vue';
import { useSettingsBreadcrumbs } from '@/mixins/settings-breadcrumbs';
import { isModelEqualToModel, cloneModel } from '@/model/model-utils';
import { performDispatchAction, performSaveAction } from '@/services/vue-utils';
import SettingsForm from '@/components/layouts/SettingsForm.vue';
import SettingsGroup from '@/components/layouts/SettingsGroup.vue';
import { ValidationObserver } from 'vee-validate';
import store from '@/store/store';
import FeedbackSettings from '@/grpc-api/model/feedback-settings';
import { loadStoreModule, unloadStoreModule } from '@/services/module-loader';
import FeedbackStore from '@/store/feedback-store';
import PaywallButton from '@/components/buttons/PaywallButton.vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'Feedback',
  setup(__props) {

const isFeedbackFeatureAllowed = computed<boolean>(() => store.getters.isFeedbackFeatureAllowed);

const router = useRouter();

const observerRef = ref(null as null | InstanceType<typeof ValidationObserver>);

const s = ref(new FeedbackSettings()) as Ref<FeedbackSettings>;
const olds = ref(cloneModel(s.value)) as Ref<FeedbackSettings>;
const isLoaded = ref(false) as Ref<boolean>;

const isChanged = computed(() => s.value && olds.value && !isModelEqualToModel(s.value, olds.value));

const changeEnable = (enabled: boolean) => {
  s.value.enabled = enabled;
  s.value.useBreakdown = (enabled && olds.value.useBreakdown === undefined) ? true : olds.value.useBreakdown;
};

const changeUseBreakdown = (useBreakdown: boolean) => { s.value.useBreakdown = useBreakdown; };

const load = async () => {
  const settings = await performDispatchAction('loadFeedbackSettings', {}) as FeedbackSettings | null;
  if (!settings) return;

  isLoaded.value = true;
  s.value = settings;
  olds.value = cloneModel(s.value);
};

const save = async () => {
  let newSettings: FeedbackSettings | undefined;
  const ok = await performSaveAction(
    observerRef.value,
    async () => { newSettings = await store.dispatch('setFeedbackSettings', { settings: s.value }); },
  );
  if (!ok || !newSettings) return;

  s.value = newSettings;
  olds.value = cloneModel(s.value);
};

const reset = async () => {
  store.dispatch('resetFeedback');
};

onBeforeUnmount(() => {
  unloadStoreModule(getCurrentInstance()?.proxy!, 'feedback', async () => { reset(); });
});

onMounted(() => {
  loadStoreModule(getCurrentInstance()?.proxy!, 'feedback', FeedbackStore, async () => { load(); });
});

const configureMessage = () => router.replace('/settings/message-center?message-channel=email&event-type=tbe_thankyou');


return { __sfc: true,isFeedbackFeatureAllowed, router, observerRef, s, olds, isLoaded, isChanged, changeEnable, changeUseBreakdown, load, save, reset, configureMessage, useSettingsBreadcrumbs, SettingsForm, SettingsGroup, ValidationObserver, PaywallButton }
}

})